/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_DeletedInputs */

const vi_meeting_guest_deleted = /** @type {(inputs: Meeting_Guest_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xoá khách mời khỏi danh bạ`)
};

/**

* @param {Meeting_Guest_DeletedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_deleted = /** @type {((inputs?: Meeting_Guest_DeletedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_DeletedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_deleted(inputs)
});